import { render, staticRenderFns } from "./TimetableView-Text.vue?vue&type=template&id=2b5165c8"
import script from "./TimetableView-Text.vue?vue&type=script&lang=js"
export * from "./TimetableView-Text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports